import React from "react";
import Tooltip from "@mui/material/Tooltip";

export const productListCellText = (value: unknown): string => {
  if (value == null) {
    return "";
  }
  return String(value).trim();
};

interface ProductListCellProps {
  value: unknown;
  onClick?: () => void;
  preserveCase?: boolean;
}

const ProductListCell: React.FC<ProductListCellProps> = ({
  value,
  onClick,
  preserveCase = false,
}) => {
  const text = productListCellText(value);
  const className = [
    "product-cell-clamp",
    onClick ? "product-cell-clamp--link" : "",
    preserveCase ? "product-cell-clamp--raw" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const cell = (
    <span className={className} onClick={onClick}>
      {text || " "}
    </span>
  );
  if (!text) {
    return cell;
  }
  return (
    <Tooltip
      title={text}
      enterDelay={0}
      enterNextDelay={0}
      leaveDelay={0}
      placement="top"
      arrow
    >
      {cell}
    </Tooltip>
  );
};

export default ProductListCell;
